"use strict";

const SAFE_ASSET_PATH = /^(?:https?:\/\/[^"'<>` ]+|\/\/[^"'<>` ]+|\/[^"'<>` ]+|\S+\.(?:jpg|jpeg|png|webp|mp4)(?:\?\S*)?)$/i;

function cleanPath(value) {
  const next = String(value || "").trim();
  return SAFE_ASSET_PATH.test(next) ? next : "";
}

function activateMedia(product, button) {
  const mainImage = product.querySelector(".product-main-image");
  const mainVideo = product.querySelector(".product-main-video");
  const videoSource = mainVideo ? mainVideo.querySelector("source") : null;
  const kind = String(button.dataset.kind || "").trim();

  if (kind === "video") {
    const nextVideo = cleanPath(button.dataset.video);
    if (!nextVideo || !mainVideo) return;
    document.querySelectorAll(".product-main-video").forEach((video) => {
      if (video !== mainVideo) video.pause();
    });
    if (mainImage) mainImage.hidden = true;
    mainVideo.hidden = false;
    if (videoSource && videoSource.getAttribute("src") !== nextVideo) {
      videoSource.setAttribute("src", nextVideo);
      mainVideo.load();
    } else if (!videoSource && mainVideo.getAttribute("src") !== nextVideo) {
      mainVideo.setAttribute("src", nextVideo);
      mainVideo.load();
    }
    mainVideo.currentTime = 0;
    const playback = mainVideo.play();
    if (playback && typeof playback.catch === "function") playback.catch(() => {});
  } else if (kind === "image") {
    const nextImage = cleanPath(button.dataset.image);
    if (!nextImage || !mainImage) return;
    if (mainVideo) {
      mainVideo.pause();
      mainVideo.hidden = true;
    }
    mainImage.hidden = false;
    mainImage.setAttribute("src", nextImage);
  }

  product.querySelectorAll("[data-kind]").forEach((item) => item.classList.remove("active"));
  button.classList.add("active");
}

document.querySelectorAll("[data-product-card]").forEach((product) => {
  product.querySelectorAll("[data-kind]").forEach((button) => {
    button.addEventListener("click", () => activateMedia(product, button));
  });
});

function syncInventory(form) {
  const select = form.querySelector("select[data-size-select]");
  const selected = select ? select.options[select.selectedIndex] : null;
  const hasSelection = selected ? Boolean(selected.value) : true;
  const available = hasSelection && (selected
    ? selected.dataset.available === "true"
    : form.dataset.available === "true");
  const scope = form.closest(".product-meta, .product-page-info");
  const status = scope ? scope.querySelector("[data-stock-status]") : null;
  const button = form.querySelector("[data-add-button]");

  if (status) {
    status.textContent = !hasSelection ? "Selecciona talla" : (available ? "In stock" : "Sold out");
    status.classList.toggle("is-pending", !hasSelection);
    status.classList.toggle("is-available", hasSelection && available);
    status.classList.toggle("is-sold-out", hasSelection && !available);
  }

  if (button) {
    button.disabled = !available;
    button.textContent = !hasSelection
      ? (button.dataset.chooseLabel || "Elige talla")
      : (available ? button.dataset.addLabel : button.dataset.soldLabel);
  }
}

document.querySelectorAll("[data-inventory-form]").forEach((form) => {
  const select = form.querySelector("select[data-size-select]");
  if (select) {
    select.addEventListener("change", () => syncInventory(form));
  }
  syncInventory(form);
});

function formatStoreMoney(cents, currency) {
  const amount = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "es-ES", {
      style: "currency",
      currency: currency || "EUR",
    }).format(amount);
  } catch (_error) {
    return `${amount.toFixed(2)} ${currency || "EUR"}`;
  }
}

document.querySelectorAll("[data-product-purchase]").forEach((purchase) => {
  const form = purchase.querySelector("form.product-form");
  const variantsNode = purchase.querySelector("[data-product-variants]");
  const variantInput = form ? form.querySelector("[data-variant-id]") : null;
  const fieldsets = Array.from(purchase.querySelectorAll("[data-option-position]"));
  const button = form ? form.querySelector("[data-add-button]") : null;
  const status = purchase.querySelector("[data-stock-status]");
  const prompt = purchase.querySelector("[data-selection-prompt]");
  const dynamicCheckout = purchase.querySelector("[data-dynamic-checkout]");
  const price = purchase.querySelector("[data-product-price]");
  const compare = purchase.querySelector("[data-product-compare]");
  const currency = purchase.dataset.currency || "EUR";

  if (!form || !variantsNode || !variantInput || !button) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsNode.textContent);
  } catch (_error) {
    return;
  }

  const fallbackSizes = Array.from(form.querySelectorAll("[data-fallback-size]"));
  if (fallbackSizes.length > 0) {
    const defaultVariant = variants[0];
    const updateFallbackSize = () => {
      const selectedSize = form.querySelector("[data-fallback-size]:checked");
      const available = Boolean(selectedSize && defaultVariant && defaultVariant.available);
      button.disabled = !available;
      button.textContent = selectedSize
        ? (available ? button.dataset.addLabel : button.dataset.soldLabel)
        : button.dataset.chooseLabel;
      if (status) {
        status.textContent = selectedSize
          ? (available ? "Disponible" : button.dataset.soldLabel)
          : "Selecciona tu talla";
        status.classList.toggle("is-pending", !selectedSize);
        status.classList.toggle("is-available", available);
        status.classList.toggle("is-sold-out", Boolean(selectedSize) && !available);
      }
      if (prompt) prompt.hidden = Boolean(selectedSize);
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
    };

    fallbackSizes.forEach((input) => input.addEventListener("change", updateFallbackSize));
    form.addEventListener("submit", (event) => {
      if (!form.querySelector("[data-fallback-size]:checked") || !defaultVariant?.available) {
        event.preventDefault();
        if (prompt) prompt.hidden = false;
        fallbackSizes[0].focus();
      }
    });
    updateFallbackSize();
    return;
  }

  function selectedValues() {
    return fieldsets.map((fieldset) => {
      const selected = fieldset.querySelector("[data-option-value]:checked");
      return selected ? selected.value : null;
    });
  }

  function matchingVariant(values) {
    if (values.some((value) => value === null)) return null;
    return variants.find((variant) =>
      variant.options.every((option, index) => option === values[index])
    ) || null;
  }

  function updateOptionAvailability(values) {
    fieldsets.forEach((fieldset, optionIndex) => {
      fieldset.querySelectorAll("[data-option-value]").forEach((radio) => {
        const hasAvailableMatch = variants.some((variant) => {
          if (!variant.available || variant.options[optionIndex] !== radio.value) return false;
          return values.every((value, index) => {
            if (index === optionIndex || value === null) return true;
            return variant.options[index] === value;
          });
        });
        const label = form.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
        radio.disabled = !hasAvailableMatch && !radio.checked;
        if (label) {
          label.classList.toggle("is-unavailable", !hasAvailableMatch);
          label.setAttribute("aria-disabled", String(!hasAvailableMatch));
        }
      });
    });
  }

  function updatePurchase() {
    const values = selectedValues();
    const complete = fieldsets.length === 0 || values.every((value) => value !== null);
    const variant = complete ? matchingVariant(values) : null;

    updateOptionAvailability(values);

    if (!complete || !variant) {
      button.disabled = true;
      button.textContent = button.dataset.chooseLabel;
      if (status) {
        status.textContent = "Selecciona tu talla";
        status.classList.remove("is-available", "is-sold-out");
        status.classList.add("is-pending");
      }
      if (prompt) prompt.hidden = false;
      if (dynamicCheckout) dynamicCheckout.hidden = true;
      return;
    }

    variantInput.value = String(variant.id);
    variantInput.dispatchEvent(new Event("change", { bubbles: true }));

    if (price) price.textContent = formatStoreMoney(variant.price, currency);
    if (compare) {
      const showCompare = Number(variant.compare_at_price) > Number(variant.price);
      compare.hidden = !showCompare;
      compare.textContent = showCompare
        ? formatStoreMoney(variant.compare_at_price, currency)
        : "";
    }

    button.disabled = !variant.available;
    button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
    if (status) {
      status.textContent = variant.available ? "Disponible" : button.dataset.soldLabel;
      status.classList.toggle("is-available", variant.available);
      status.classList.toggle("is-sold-out", !variant.available);
      status.classList.remove("is-pending");
    }
    if (prompt) prompt.hidden = true;
    if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set("variant", String(variant.id));
    window.history.replaceState({}, "", nextUrl);
  }

  fieldsets.forEach((fieldset) => {
    fieldset.addEventListener("change", updatePurchase);
  });

  form.addEventListener("submit", (event) => {
    const variant = matchingVariant(selectedValues());
    if (!variant || !variant.available) {
      event.preventDefault();
      if (prompt) prompt.hidden = false;
      const firstMissing = fieldsets.find(
        (fieldset) => !fieldset.querySelector("[data-option-value]:checked")
      );
      const firstChoice = firstMissing && firstMissing.querySelector("[data-option-value]");
      if (firstChoice) firstChoice.focus();
    }
  });

  updatePurchase();
});

const menuToggle = document.querySelector("[data-mobile-menu-toggle]");
const mobileMenu = document.querySelector("[data-mobile-menu]");
if (menuToggle && mobileMenu) {
  menuToggle.addEventListener("click", () => {
    const isHidden = mobileMenu.hasAttribute("hidden");
    mobileMenu.toggleAttribute("hidden", !isHidden);
    menuToggle.setAttribute("aria-expanded", String(isHidden));
  });
}
